import { useQuery } from "@/api/swr/useQuery";
import { simpleAssessmentDetailSchema } from "@/schema/console/simple-assessments/SimpleAssessmentDetail";

type Config = Parameters<
  typeof useQuery<typeof simpleAssessmentDetailSchema>
>[2];

export function useGetLatestSimpleAssessment(config: Config) {
  return useQuery(
    simpleAssessmentDetailSchema,
    `/console/assessment_papers/latest?is_premium=false`,
    config,
  );
}
